import { useTranslation } from "react-i18next";
import { Button } from 'primereact/button';
import {useRef, useState } from "react";
import {useReactToPrint} from "react-to-print"
import React from "react";
import { Toolbar } from "primereact/toolbar";
import { Card } from "primereact/card";
import eposiSolucoes from "../../assets/logoeposi.png"

import RespostaInsumoPage from "./resposta/RespostaInsumo";


export default function ConsultaPage({
  resposta,
  onClose,
  original
}: {
  resposta: any
  onClose: () => void,
  original: boolean
}) {
  const { t } = useTranslation();
  const print = useRef(null);
  const handlePrint = useReactToPrint({
    content : () => print.current,

  })
   
  const startContent = (
    <React.Fragment>
        <Button label="Imprimir" icon="pi pi-print" style={{backgroundColor:'#183462'}} onClick={() => {handlePrint()}}/>
    </React.Fragment>
);

const endContent = (
  <React.Fragment>
      <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />  
  </React.Fragment>
);

const razaoSocialOuNome = '';
const rodapeMensagem = `ATENÇÃO: As informações deste relatório são confidenciais e deverão ser utilizadas exclusivamente para orientação das transações comerciais, responsabilizando-se civil e criminalmente por danos causados a terceiros, quando da utilização em desacordo com a legislação em vigor.`;

return (<>
  <Toolbar start={startContent} end={endContent}/>
  <br></br>
  <br></br>
    <div ref={print} className="flex flex-column align-items-center" >
    <style type="text/css" media="print">{"\
  @page {\ size: portrait; font-size: 6pt; .label-dados {font-size: 6pt;}; margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important;\ }\
"}</style>
      <br></br>
      <Card>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap" style={{ marginTop: '1.5rem'}}>
            <img src={eposiSolucoes} style={{width:'200px'}}></img>
          </div>
          <div style={{textAlign:'center'}} className="col p-fluid flex flex-wrap">
            <h1>{resposta.informativo.opcoesPai}</h1>
            <h5>{resposta.informativo.opcoes}</h5>
          </div>
          <div style={{textAlign:'center'}} className="col p-fluid flex flex-wrap">

          </div>
        </div>
      </Card>
      
      <RespostaInsumoPage resposta={resposta}></RespostaInsumoPage>
      
      
      <br></br>
      <Card>
        <p style={{ fontSize: '10px', textAlign: 'center' }}>
          {rodapeMensagem}
        </p>
      </Card>
    </div>
    <br></br>
    <br></br>
    <Toolbar start={startContent} end={endContent}/>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
  </>)
}
